<div>

  <div class="website-container">
    <div class="search-bar-wrap" [ngClass]="{
      'list-page': pageType === pageTypes.LIST_PAGE,
    }">
      @if (layoutData?.headerContainer) {
        @for (container of layoutData?.headerContainer; track container) {
          <div class="header-section" [style]="{ 'min-height': container?.sliderMinHeight + 'px'}">
            @switch (container?.component) {
              @case ('DesktopShortStaySearchFormComponent') {
                <app-b2b-shortstay-form [compData]="{
                container: container
              }">
                </app-b2b-shortstay-form>
              }
              @default {
                @if (((container?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                  <ng-container *ngComponentOutlet="component; inputs: {
                  compData: {
                      container: container
                  }
                }"/>
                }
              }
            }
          </div>
        }
      } @else {
        <div class="loading search-box-loader"></div>
      }
      <!-- @for (container of layoutData?.headerContainer; track container) {
         <div class="header-section" [style]="{ 'min-height': container?.sliderMinHeight + 'px'}">
           @switch (container?.component) {
             @case ('DesktopShortStaySearchFormComponent') {
               <app-b2b-shortstay-form [compData]="{
                 container: container
               }">
               </app-b2b-shortstay-form>
             }
             @default {
               @if (((container?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                 <ng-container *ngComponentOutlet="component; inputs: {
                   compData: {
                       container: container
                   }
                 }"/>
               }
             }
           }
         </div>
       }-->
    </div>
    <ng-container *ngTemplateOutlet="contentTemplate;"></ng-container>
  </div>
</div>

<ng-template #contentTemplate>
  @if ((layoutData?.mainContainer?.length > 0)) {
    <div class="main-body">
      @for (container of layoutData?.mainContainer; track container; let index = $index) {
        @switch (container.component) {
          @case ('BreadCrumbComponent') {
            <div class="breadcrumb-wrap">
              <app-b2b-breadcrumb [compData]="{ container: container }"></app-b2b-breadcrumb>
            </div>
          }
          @case ('HeadingComponent') {
            <div class="heading-wrap">
              <app-b2b-heading [compData]="{ container: container, showH1: true }"></app-b2b-heading>
            </div>
          }
          @case ('FilterButtonsComponent') {
            <div class="filter-btn-wrap">
              @if (!isServer) {
                <app-b2b-filter-buttons [compData]="{ container: container }"></app-b2b-filter-buttons>
              }
            </div>
          }
          @case ('RowLeftRightLayoutComponent') {
            <div class="layout-wrap">
              @for (nestedContainer of container?.containers; track nestedContainer) {
                <div class="layout-inner-wrap">
                  @switch (nestedContainer?.component) {
                    @case ('DesktopFilterCardComponent') {
                      @if (!isServer) {
                        <app-b2b-desktop-filter-card
                          [compData]="{
                      container: nestedContainer
                    }"
                        ></app-b2b-desktop-filter-card>
                      }
                    }
                    @case ('InfiniteScrollComponent') {
                      <lib-feature-list-infinite-scroll
                        [compData]="{ container: nestedContainer, index: index }"
                        [isSeoPage]="isSeoPage"
                      >
                      </lib-feature-list-infinite-scroll>
                    }
                    @case ('OverlayCardComponent') {
                      @if (!isServer) {
                        <app-b2b-overlay-card
                          [compData]="{ container: nestedContainer}"
                        >
                        </app-b2b-overlay-card>
                      }
                    }
                    @default {
                      @if (((nestedContainer?.component | b2bDynamicLoaderPipe) | async); as component) {
                        <ng-container *ngComponentOutlet="component; inputs: {
                        compData: {
                            container: nestedContainer
                        }
                      }"/>
                      }
                    }
                  }
                </div>
              }
            </div>
          }
          @case ('SeoProductComponent') {
            <app-small-property-card-v2
              [compData]="{ container: container }"
            >
            </app-small-property-card-v2>
          }
          @default {
            <div id="{{ container?.key }}" class="dynamic-small-card"
                 [style]="{ 'min-height': container?.sliderMinHeight + 'px'}"
            >
              <div class="">
                @if (((container?.component | b2bDynamicLoaderPipe) | async); as component) {
                  <ng-container *ngComponentOutlet="component; inputs: {
                  compData: {
                      container: container
                  }
                }"/>
                }
              </div>
            </div>
          }
        }
      }
    </div>
  } @else {
    @if (!skeletonKeys.errorLoaded) {
      <div class="d-sk">
        <!--<div class="loading search-box"></div>-->
        <div class="box-pad">
          <div class="loading box-1"></div>
          <div class="loading box-2"></div>
          <div class="box-grid">
            <div class="loading box-3"></div>
            <div class="loading box-4"></div>
          </div>
          <div class="box-grid-2">
            <div class="left-layout">
              <div class="loading box-5"></div>
            </div>
            <div class="middle-layout">
              <div class="loading box-6"></div>
              <div class="loading box-7"></div>
              <div class="loading box-8"></div>
              <div class="loading box-9"></div>
            </div>
          </div>
        </div>
      </div>
    }
  }

  @if (errorContainers?.length > 0) {
    @for (errorContainer of errorContainers; track errorContainer) {
      @if (((errorContainer?.component | b2bDynamicLoaderPipe) | async); as component) {
        <div class="error-container">
          <app-b2b-dynamic-data-card
            [compData]="{
                  container: errorContainer
                }"
          ></app-b2b-dynamic-data-card>
        </div>
      }
    }
  }
</ng-template>
